import { create } from 'zustand';

const useAuthStore = create((set) => ({
    accessToken: null,
    user: null,
    isAuthenticated: false,

    setAccessToken: (token) => set({ accessToken: token, isAuthenticated: !!token }),
    setUser: (user) => set({ user }),
    login: (token, user) => set({ accessToken: token, user, isAuthenticated: true }),
    logout: () => set({ accessToken: null, user: null, isAuthenticated: false }),
}));

export default useAuthStore;
